export default {
  name: 'satisfaction-survey',
  components: {},
  props: {
    satisfactionSurveyInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      surveyUrl: '/academy/help/?category_id=6601707512485904398',
      isShowSurveyPop: true
    }
  },
  methods: {
    goToSurvey () {
      window.open(this.globalUpdateQuery(`https://bytedance.wjx.cn/jq/36696354.aspx?sojumpparm=${this.satisfactionSurveyInfo.key}`))
    },
    closeSurveyPop () {
      this.isShowSurveyPop = false
      window.sessionStorage.setItem('HIDE_SATISFACTION_SURVEY_POP', true)
    }
  },
  mounted () {
    this.isShowSurveyPop = !window.sessionStorage.getItem('HIDE_SATISFACTION_SURVEY_POP')
  }
}
